// extracted by mini-css-extract-plugin
export var footer = "ProjectFooter-module--footer--KwiCW";
export var container = "ProjectFooter-module--container--yUVaB";
export var title = "ProjectFooter-module--title--7azkq";
export var contactMe = "ProjectFooter-module--contact-me--XS0kD";
export var createdOn = "ProjectFooter-module--created-on---cjDP";
export var createdOnTitle = "ProjectFooter-module--created-on-title--vc4bh";
export var createdOnIcons = "ProjectFooter-module--created-on-icons--HH-Ob";
export var createdOnIcon = "ProjectFooter-module--created-on-icon--Qy7Ep";